/**
 * Check if a user has permission for a specific resource and action
 * @param {Object} permissions - The user's permissions object
 * @param {string} resource - The resource to check permissions for
 * @param {string} action - The action to check permissions for
 * @returns {boolean} - Whether the user has the permission
 */
export const hasPermission = (permissions, resource, action) => {
  console.log('hasPermission check:', { permissions, resource, action });
  
  if (!permissions || !permissions.resources) {
    console.log('No permissions or resources found');
    return false;
  }
  
  const resourcePermissions = permissions.resources[resource];
  if (!resourcePermissions || !resourcePermissions.actions) {
    console.log(`No permissions found for resource: ${resource}`);
    return false;
  }
  
  const hasAction = !!resourcePermissions.actions[action];
  console.log(`Permission for ${resource}:${action} is ${hasAction}`);
  return hasAction;
};

/**
 * Check if a user has permission for a specific resource and any of the provided actions
 * @param {Object} permissions - The user's permissions object
 * @param {string} resource - The resource to check permissions for
 * @param {string[]} actions - The actions to check permissions for
 * @returns {boolean} - Whether the user has any of the permissions
 */
export const hasAnyPermission = (permissions, resource, actions) => {
  return actions.some(action => hasPermission(permissions, resource, action));
};

/**
 * Get the regions a user has permission for a specific resource and action
 * @param {Object} permissions - The user's permissions object
 * @param {string} resource - The resource to check permissions for
 * @param {string} action - The action to check permissions for
 * @returns {string[]} - Array of region IDs the user has permission for
 */
export const getPermittedRegions = (permissions, resource, action) => {
  if (!permissions || !permissions.resources) return [];
  
  const resourcePermissions = permissions.resources[resource];
  if (!resourcePermissions || !resourcePermissions.actions) return [];
  
  const actionPermission = resourcePermissions.actions[action];
  if (!actionPermission || !actionPermission.attributes || !actionPermission.attributes.region_ids) return [];
  
  return actionPermission.attributes.region_ids;
};

/**
 * Filter an array of items based on the user's region permissions
 * @param {Object} permissions - The user's permissions object
 * @param {string} resource - The resource to check permissions for
 * @param {string} action - The action to check permissions for
 * @param {Array} items - Array of items to filter
 * @param {Function} getItemRegion - Function to extract region ID from an item
 * @returns {Array} - Filtered array of items
 */
export const filterByRegionPermission = (permissions, resource, action, items, getItemRegion) => {
  const permittedRegions = getPermittedRegions(permissions, resource, action);
  
  if (permittedRegions.length === 0) return [];
  
  return items.filter(item => {
    const itemRegion = getItemRegion(item);
    return permittedRegions.includes(itemRegion.toString());
  });
}; 